import { Box, Typography } from '@mui/material';
import { aiGradientTextSx } from 'common/constants/ai';
import {
  commentaryListSx,
  confidenceLabelSx,
  confidenceRowSx,
  confidenceValueSx,
} from 'pages/CapTable/cap-table/components/ai-security-finding-popover/AISecurityFindingPopover.styles';
import GradientDivider from 'pages/Documents/components/SuggestedDocumentReference/GradientDivider';
import {
  commentaryItemSx,
  commentaryTitleSx,
} from 'pages/Documents/components/SuggestedDocumentReference/SuggestedDocumentReference.styles';

interface AIFindingBodyProps {
  confidence?: number | null;
  overallConfidence?: number | null;
  commentary?: string[];
}

const AIFindingBody = ({ confidence, overallConfidence, commentary = [] }: AIFindingBodyProps) => (
  <>
    {(confidence != null || overallConfidence != null) && (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {confidence != null && (
          <Box sx={confidenceRowSx}>
            <Typography variant="body2" sx={confidenceLabelSx}>
              Field confidence:
            </Typography>
            <Typography
              variant="body2"
              sx={{
                ...confidenceValueSx,
                ...(aiGradientTextSx as Record<string, unknown>),
              }}>
              {Math.round(confidence * 100)}%
            </Typography>
          </Box>
        )}
        {overallConfidence != null && (
          <Box sx={confidenceRowSx}>
            <Typography variant="body2" sx={confidenceLabelSx}>
              Overall accuracy:
            </Typography>
            <Typography
              variant="body2"
              sx={{
                ...confidenceValueSx,
                ...(aiGradientTextSx as Record<string, unknown>),
              }}>
              {Math.round(overallConfidence * 100)}%
            </Typography>
          </Box>
        )}
      </Box>
    )}

    {commentary.length > 0 && (
      <>
        <GradientDivider />
        <Box>
          <Typography variant="body2" sx={commentaryTitleSx}>
            Commentary
          </Typography>
          <Box component="ul" sx={commentaryListSx}>
            {commentary.map((note, index) => (
              <Typography
                key={index}
                component="li"
                variant="body2"
                color="text.secondary"
                sx={commentaryItemSx}>
                {note}
              </Typography>
            ))}
          </Box>
        </Box>
      </>
    )}
  </>
);

export default AIFindingBody;
